import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  drawerIsOpenAtom,
  drawerTypeAtom,
} from '@/features/equipment-browser/equipment-drawer-loader/state/drawer.state';

import {
  deviceIdsAtom,
  deviceKindAtom,
  pushOutModeAtom,
  titleOverrideAtom,
} from '../state/bulk-edit-params.state';

export const useOpenBulkEdit = () => {
  const setDeviceKind = useSetAtom(deviceKindAtom);
  const setDeviceIds = useSetAtom(deviceIdsAtom);
  const setDrawerIsOpen = useSetAtom(drawerIsOpenAtom);
  const setDrawerType = useSetAtom(drawerTypeAtom);
  const setPushOutMode = useSetAtom(pushOutModeAtom);
  const setTitleOverride = useSetAtom(titleOverrideAtom);

  /**
   * @param titleOverride Header title to use instead of the device-kind one from the
   *   view config — pass the section name when the selection is scoped to a section.
   *   Always written, including as `undefined`, so an unscoped open cannot inherit the
   *   title of a previously opened section.
   */
  const openBulkEditAction = (deviceKind: string, deviceIds: string[], titleOverride?: string) => {
    setDeviceKind(deviceKind);
    setDeviceIds(deviceIds);
    setTitleOverride(titleOverride);
    setDrawerType('bulk-edit');
    setDrawerIsOpen(true);
  };

  const clearBulkEditAction = useCallback(() => {
    setDeviceKind(undefined);
    setDeviceIds(undefined);
    setTitleOverride(undefined);
    setDrawerIsOpen(false);
    setDrawerType(undefined);
    setPushOutMode(null);
  }, [
    setDeviceIds,
    setDeviceKind,
    setDrawerIsOpen,
    setDrawerType,
    setPushOutMode,
    setTitleOverride,
  ]);

  return {
    openBulkEditAction,
    clearBulkEditAction,
  };
};
